"use strict";
/*
 * Takes a number and rounds it to the desired number of decimals
 *
 * @Param {number} value = The number to round
 * @Param {number} decimals = Number of decimals
 *
 * @Example
 *
 *   round(0.44, 1)
 *   //=> 0.4
 *
 * @Example
 *
 *   round(0.45, 1)
 *   //=> 0.5
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.round = (value, decimals) => Number(`${Math.round(Number(`${value}e${decimals}`))}e-${decimals}`);
//# sourceMappingURL=round.js.map